import { Directive, OnInit, OnChanges, Input, ElementRef, Inject, PLATFORM_ID, Optional, Self } from '@angular/core';
import { BaseFxDirective, MediaMonitor, StyleUtils, SERVER_TOKEN } from '@angular/flex-layout';
import { MatGridList } from '@angular/material';

@Directive({
  selector: `
  mat-grid-list[cols.xs],    mat-grid-list[cols.sm],    mat-grid-list[cols.md],    mat-grid-list[cols.lg],   mat-grid-list[cols.xl],
  mat-grid-list[cols.lt-sm], mat-grid-list[cols.lt-md], mat-grid-list[cols.lt-lg], mat-grid-list[cols.lt-xl],
  mat-grid-list[cols.gt-xs], mat-grid-list[cols.gt-sm], mat-grid-list[cols.gt-md], mat-grid-list[cols.gt-lg]
`
})
export class ResponsiveGridDirective extends BaseFxDirective implements OnInit, OnChanges {

  /* tslint:disable */
  @Input('cols')        set colsBase(val) { this._cacheInput('cols', val);  }

  @Input('cols.xs')     set colsXs(val)   { this._cacheInput('colsXs', val);  }
  @Input('cols.sm')     set colsSm(val)   { this._cacheInput('colsSm', val);  }
  @Input('cols.md')     set colsMd(val)   { this._cacheInput('colsMd', val);  }
  @Input('cols.lg')     set colsLg(val)   { this._cacheInput('colsLg', val);  }
  @Input('cols.xl')     set colsXl(val)   { this._cacheInput('colsXl', val);  }

  @Input('cols.lt-sm')  set colsLtSm(val) { this._cacheInput('colsLtSm', val);  }
  @Input('cols.lt-md')  set colsLtMd(val) { this._cacheInput('colsLtMd', val);  }
  @Input('cols.lt-lg')  set colsLtLg(val) { this._cacheInput('colsLtLg', val);  }
  @Input('cols.lt-xl')  set colsLtXl(val) { this._cacheInput('colsLtXl', val);  }

  @Input('cols.gt-xs')  set colsGtXs(val) { this._cacheInput('colsGtXs', val);  }
  @Input('cols.gt-sm')  set colsGtSm(val) { this._cacheInput('colsGtSm', val);  }
  @Input('cols.gt-md')  set colsGtMd(val) { this._cacheInput('colsGtMd', val);  }
  @Input('cols.gt-lg')  set colsGtLg(val) { this._cacheInput('colsGtLg', val);  }
  /* tslint:enable */

  constructor(protected _elRef: ElementRef,
              protected _monitor: MediaMonitor,
              protected _styler: StyleUtils,
              @Self() protected _grid: MatGridList,
              @Inject(PLATFORM_ID) protected _platformId: Object,
              @Optional() @Inject(SERVER_TOKEN) protected _serverModuleLoaded: boolean) {
    super(_monitor, _elRef, _styler);
    this._cacheInput('cols', _grid.cols || '');
  }

  /**
   * Listen for responsive changes to update the img.src attribute
   */
  ngOnInit() {
    super.ngOnInit();

    if (this.hasResponsiveKeys) {
      // Listen for responsive changes
      this._listenForMediaQueryChanges('cols', this._queryInput('cols'), () => {
        this._update();
      });
    }
    this._update();
  }

  /**
   * Update the 'src' property of the host <img> element
   */
  ngOnChanges() {
    if (this.hasInitialized) {
      this._update();
    }
  }

    protected _update() {
    if (this.hasResponsiveKeys) {
      let value = this.activatedValue || this._queryInput('cols');
      this._grid.cols = Number(value);
    }
  }

    protected get hasResponsiveKeys() {
    return Object.keys(this._inputMap).length > 1;
  }

}


// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/directives/responsive-grid.directive.ts